import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  migrationId: string;
  consultantId: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_consultant',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveMigrationConsultant = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveMigrationConsultantLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationConsultant;
